import Header from '../components/Header'
import { atom, useAtom } from 'jotai'
import React from 'react';
import PropTypes from 'prop-types';
// import Image from 'next/image'
// import Link from 'next/link'
// import { HashLink as Link } from 'react-router-hash-link';
// import { NavHashLink } from 'react-router-hash-link';
//import TimelineThumb from '../components/TimelineNavigation'
// import { GalleryItemDetail } from '../components/GalleryItemDetail'
import {  useLocation, useParams, useNavigate } from "react-router-dom";

import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'

import {slideIndexAtom} from '../atoms/atom.config.js'
import {isSmallAtom} from '../atoms/atom.config.js'
import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth } from '../constants';

import _ from "lodash"

import { FullPage, Slide } from 'react-full-page';
import animatedScrollTo from '../utils/animated-scroll-to';
import isMobileDevice from '../utils/is-mobile';

// svgr: https://react-svgr.com/docs/next/
// import ScrollDownIcon from '../assets/icons/button_close.svg'

// assets
// import notesImage from '../assets/images/default_thumb.jpg'
// import notesImage from './default_thumb.jpg'
// import timelineImage from '../assets/icons/icon_object.svg'
// import {OutlineButtonTextIcon, ButtonTextIcon} from '../components/Button'
import SlideFull from '../components/Slides'

// assets
// import logoImage from '../assets/images/default_thumb.jpg'
// import scrollDownIcon from '../assets/icons/icon_scrolldown.svg'
// import scrollObjectIcon from "../assets/icons/icon_object.svg"
// import culturalIcon from "../assets/icons/icon_cultural_large.svg"
// import securityIcon from "../assets/icons/icon_security_large.svg"
import scrollerDotIcon from "../assets/icons/icon_dot_page.svg"
import scrollerDotActiveIcon from "../assets/icons/icon_dot_current_page.svg"

// components
// import VideoBackground from '../components/VideoBackground';
// import bgVideo from '../assets/videos/00_Introduction.mp4';


// page icon for the side scroller navigation
const ScrollerIcon = (props) => {
  // testing only
  const onBlurFocus = () => {
    console.log("onBlurFocus", props)
    console.log("onBlurFocus timeout", document.activeElement, document.activeElement.id);
    setTimeout(() => {
      console.log("onBlurFocus timeout2", document.activeElement, document.activeElement.id);
    },500);
    //if(props.blurEvent) props.blurEvent()
  };

  const cn = `w-8 h-6 flex flex-row justify-center cursor-pointer transition-transform hover:scale-125 ${(props.active) ? 'transition-transform scale-125' : ''}`;
  return (
    // <div className={`banner ${active ? "active" : ""}`}>{children}</div>
    // <div onClick={props.onClick} className={cn}><img src={props.active ? scrollerDotActiveIcon : props.src } alt="" width={8} /></div>
    <div className={cn}><button tabIndex={props.tabIndex} onClick={props.onClick} ><img src={props.active ? props.icons.active : props.icons.icon } alt={props.icons.alt} width={props.icons.size} /></button></div>
    // <button tabIndex={props.tabIndex} className="mb-3 flex flex-row items-center justify-center h-12 opacity-100 transition duration-200 hover:opacity-50" onClick={props.onClick} ></button>
    // {props.index}
  )
};

const ScrollerControls = (props) => {

  return (
    <div className='fixed top-1/2 right-5 transform -translate-y-1/2 w-8 z-20 text-center'>
      <div className='flex flex-col items-center justify-center'> 
        {props.progressIcons.map((elementInArray, index) => ( 
            // <div className="" key={index}> Whatever needs to be rendered repeatedly... </div> 
            <ScrollerIcon active={props.controlsUpdate == index} icons={props.progressIcons[index]} src={props.progressIcons[index]} alt={props.progressIcons[index]} index={index} tabIndex={11+index} key={index} onClick={() => props.animateToSlideId(index)} />
            ) 
        )}
      </div>
    </div>
  )
};
/*
class ScrollerCustomControls extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    getCurrentSlideIndex: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onPrev: PropTypes.func.isRequired,
    scrollToSlide: PropTypes.func.isRequired,
    slidesCount: PropTypes.number.isRequired,
    style: PropTypes.object,
  }
  static defaultProps = {
    className: 'full-page-controls',
    style: {
      zIndex: 300,
      left: '50%',
      paddingTop: '100px',
      position: 'fixed',
      transform: 'translateX(-50%)',
    },
  }

  render() {
    const {
      getCurrentSlideIndex, slidesCount, style, className, progressIcons, showControls
    } = this.props;
    //const { slidesCount, scrollToSlide } = this.props;
    const currentSlideIndex = getCurrentSlideIndex();
    console.log("currentSlideIndex", currentSlideIndex, slidesCount)

    return (
      <div className='fixed top-1/2 right-5 transform -translate-y-1/2 w-8 z-20 text-center full-page-controls'>
        { showControls &&
        <div className='flex flex-col items-center justify-center'>
            {this.props.progressIcons.map((elementInArray, index) => ( 
                // <div className="" key={index}> Whatever needs to be rendered repeatedly... </div> 
                // onClick={() => scrollToSlide(index)} 
                <ScrollerIcon active={currentSlideIndex == index} icons={progressIcons[index]} src={progressIcons[index]} key={index} onClick={() => this.props.scrollToSlide(index)}/>
                ) 
            )} 
        </div>
        }
      </div>
    )
  }
};

class CustomControls extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    getCurrentSlideIndex: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onPrev: PropTypes.func.isRequired,
    scrollToSlide: PropTypes.func.isRequired,
    slidesCount: PropTypes.number.isRequired,
    style: PropTypes.object,
  }

  static defaultProps = {
    className: 'full-page-controls',
    style: {
      zIndex: 300,
      left: '50%',
      paddingTop: '100px',
      position: 'fixed',
      transform: 'translateX(-50%)',
    },
  }

  renderSlidesNumbers(currentSlideIndex) {
    const { slidesCount, scrollToSlide } = this.props;
    const slidesNumbers = [];
    for (let i = 0; i < slidesCount; i++) {
      const buttonProps = {
        disabled: currentSlideIndex === i,
        key: i,
        onClick: () => scrollToSlide(i),
      };
      slidesNumbers.push(<button type="button" {...buttonProps}>{i + 1}</button>);
    }
    return slidesNumbers;
  }

  render() {
    const {
      getCurrentSlideIndex, slidesCount, style, className,
    } = this.props;
    const currentSlideIndex = getCurrentSlideIndex();

    return (
      <div className={className} style={style}>
        <button
          type="button"
          // disabled={currentSlideIndex === 0}
          onClick={this.props.onPrev}
        >
          previous
        </button>
        {this.renderSlidesNumbers(currentSlideIndex)}
        <button
          type="button"
          // disabled={currentSlideIndex === slidesCount - 1}
          onClick={this.props.onNext}
        >
          next
        </button>
      </div>
    );
  }
}*/


const SlidesScroller = forwardRef((props,ref) => {
// export default function SlidesScroller(props) {
// const SlidesScroller = ((props,ref) => {
// const ScrollerSlides = () => {
  //const [value, updateValue] = useAtom(anAtom)
  //const [text, setText] = useAtom(textAtom)
  const [isSmall, ] = useAtom(isSmallAtom);
  // const [width, height] = useDeviceSize();
  const [deviceWidth, deviceHeight] = useDeviceSize();
  //const router = useRouter()
  //const elementRef = useRef(null); // this was a ref to the first slide- now passed in as prop
  //const maxSlides = 4;
  let slideHeight = 0;
  let currentScrollY = 0;
  let isScrolling=false;
  const hide=true;  
  //let currentSlideIndex = 0;
  //const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  //let currentSlideIndex = 0; // this doesnt work as a state variable with useEffect and wheelscroll- need to pass in parameters which causes re-render
  const currentSlideIndex = useRef(0)
  //const maxSlides = useRef(0)
  //const fullPageRef = useRef(null)
  let enableFullPageScroll=false;
  let prevScrollTime = useRef(new Date().getTime());
  // how long do we 'pause' between scroll triggers? 1400
  const delayedScrollPause = 2500; //1400;

  let _isScrollPending = useRef(false);
  let _isScrolledAlready = false;
  let _touchSensitivity = 5;
  let _touchStart = 0;
  let _isMobile = null;
  let _isListenersAdded = useRef(false);
  let _lastSavedScrollY = useRef(0);

  //console.log("CONSTRUCTOR currentSlideIndex", currentSlideIndex.current, "scrollPending", _isScrollPending.current, "current", currentScrollY)

  const locationParams = useParams(); //useLocation();
  const location = useLocation();
  const history = useNavigate();

  // custom state var that triggers re-render for side controls
  const [controlsUpdate, setControlsUpdate] = useState(0);

  const [savedSlideIndex, setSavedSlideIndex] = useAtom(slideIndexAtom);

  // const containerRef = useRef(null);

  //console.log("state updated- _isScrollPending: ", _isScrollPending.current)

  const setCurrentSlideIndex = (v) => {
    currentSlideIndex.current = v;
    // if(v == props.children.length-1 && v > 0) {
    //   setSavedSlideIndex(-1)
    // } else {
    //   setSavedSlideIndex(v)
    // }
    setSavedSlideIndex(v)
  };
  const getCurrentSlideIndex = () => {
    return currentSlideIndex.current;
  };
  const getCurrentSlideIndexFromControls = () => {
    return controlsUpdate;
  };

  const getEnableFullPageScroll = () => {
    // on mobile default ot normal scroll
    //console.log("getEnableFullPageScroll isSmall:", isSmall)
    return !isSmall
    //return enableFullPageScroll;
  };

  const handleChange = (e) => {
    console.log("handleChange",e)
    //setText(e.target.value);
    //setColor("blue")
  }

  // custom handler for the parent footer's 'scroll down' button
  // this is tied to the custom fullpage component only
  // const gotoNextFullPage = () => {
  //   //console.log("gotoNextFullPage", fullPageRef)
  //   if(fullPageRef) {
  //     fullPageRef.current.scrollNext()
  //   }
  // };
  
//   // goto specifix slide index (requires pre-calculated slideHeight)
// //   function gotoSlide(slideIndex) {
//   const gotoSlide = (slideIndex) => {
//     // we can calculate window hiehgt, current screen height, slide height, nav height
//     //const windowHeight = parseFloat(document.documentElement.scrollHeight);
//     //const navHeight = document.getElementById('nav').clientHeight;
//     //const slideHeight = elementRef.current.clientHeight;
//     //const pctPos = windowHeight*p;
//     //currentSlideIndex = slideIndex;
//     setCurrentSlideIndex(slideIndex);
//     if(!slideHeight) {
//       // only need to set this once - it's the main slide height
//     //   slideHeight = elementRef.current.clientHeight
//       slideHeight = props.firstSlide.current.clientHeight;
//     }
//     const slidePos = slideIndex * slideHeight;
//     //console.log("gotoSlide", slideIndex, slidePos, slideHeight);
//     window.scrollTo({
//         top: slidePos,
//         behavior: 'smooth',
//     });

//     // toggle the classlist item? https://bobbyhadz.com/blog/react-add-remove-class-on-click
//   };

//   const gotoSlideId = (slideIndex) => {
//     setCurrentSlideIndex(slideIndex);
//     //const container = document.getElementById("display");
//     const node = document.getElementById('slide' + slideIndex.toString());
//     //console.log(node,'slide' + slideIndex.toString())
//     const slidePos = node.offsetTop;
//     console.log("gotoSlideId", slideIndex, slidePos);
//     window.scrollTo({
//         top: slidePos,
//         behavior: 'smooth',
//     });
//   };
  
  const sendCustomEvent = (eventName, data) => {
    // test custom event for when the slide changes
    const event = new CustomEvent(eventName, {detail: data});
    document.dispatchEvent(event);
  };

  const forceToLastScrollPos = () => {
    const windowScrollPos = window.scrollY || window.pageYOffset
    console.log("last saved scrollY", _lastSavedScrollY.current, windowScrollPos)
    if( _lastSavedScrollY.current != windowScrollPos) {
      console.log("scrolled to position:", _lastSavedScrollY.current)
      window.scrollTo({top:_lastSavedScrollY.current,behavior: 'instant'});
    }
    
  };

  const updateUrlHistory = () => {
    if(false) {
      const sid = location.pathname.split(":");
      const url = sid[0]+":"+currentSlideIndex.current
      console.log("updateUrlHistory:", sid, url)
      //window.history.pushState(null, "", url) //"/pathname/goes/here")
      //{ replace: true, state: { bookName: "Fake Title" }}
      history(url, {state:{slide:currentSlideIndex.current}});
    } else {
      // could add google analytics code here? note this updates on slide change for the same section- we only need the page view
      //console.log("updateUrlHistory", location.pathname)
    }
    
  };

  /*
  useEffect(() => {
    console.log("pathname changed:", location)
    console.log("compare state change slide: ", currentSlideIndex.current, location.state)
    if(location.state) {
      if(location.state.slide !== currentSlideIndex.current) {
        console.log("wrong slide- need to navigate to correct slide:", location.state.slide)
        animateToSlideId(location.state.slide)
      }
    }
  }, [location]);*/

  const animateToSlideId = (slideIndex) => {
    console.log("animateToSlideId", slideIndex, _isScrollPending.current, "current", currentSlideIndex.current)
    if (!_isScrollPending.current && slideIndex >= 0) {
      //const currentSlide = currentSlideIndex
      //this.props.beforeChange({ from: currentSlide, to: slide });

      // this.setState({
      //   activeSlide: slide,
      // });
      

      const node = document.getElementById('slide' + slideIndex.toString());
      if(node) {
        

        setCurrentSlideIndex(slideIndex);
        setControlsUpdate(slideIndex); // fake state var to update controls
        console.log("new slide index:", currentSlideIndex.current, slideIndex, node)

        const slidePos = node.offsetTop;
        currentScrollY = slidePos; // save the target position for later
        _lastSavedScrollY.current = slidePos;

        // test custom event for when the slide changes
        //const event0 = new CustomEvent('onSlideAnimationBegin', {detail: slideIndex});
        //document.dispatchEvent(event0);
        sendCustomEvent('onSlideAnimationBegin', slideIndex)
  
        _isScrollPending.current = true; //900
        animatedScrollTo(slidePos, 900, () => {
          _isScrollPending.current = false;
          console.log("animation complete slide index:", currentSlideIndex.current)
          //this._isScrolledAlready = true;

          // test custom event for when the slide changes
          //const event = new CustomEvent('onSlideAnimationComplete', {detail: currentSlideIndex.current});
          //document.dispatchEvent(event);
          sendCustomEvent('onSlideAnimationComplete', currentSlideIndex.current)

          // modify the url/location with new slide id? eg. /five:10
          updateUrlHistory()
          // const sid = pathname.split(":");
          // const url = sid[0]+":"+currentSlideIndex.current
          // console.log("updating url history:", sid, url)
          // //window.history.pushState(null, "", url) //"/pathname/goes/here")
          // history(url);
  
          //this.props.afterChange({ from: currentSlide, to: slide });

          // still not working - the inertia/momentum from osx chrome scroll is too long- need to know when it actually finishes
          // appears the scroll tween continues after the animation
          // setTimeout(() => {
          //   _isScrollPending.current = false;
          //   console.log("custom interval delay:", currentSlideIndex.current)
          // },2000);

          
        });
      } else {
        console.log("node doesnt exist yet? force update for global index")
        //setCurrentSlideIndex(slideIndex);
        //setControlsUpdate(slideIndex); 
      }

    }
  };

  //function gotoNextSlide() {
  const gotoNextSlide = () => {
    //if(currentSlideIndex < )
    console.log("gotoNextSlide", currentSlideIndex.current)
    //gotoSlide(currentSlideIndex+1)
    animateToSlideId(currentSlideIndex.current+1)
  };

  const gotoPrevSlide = () => {
    //if(currentSlideIndex < )
    console.log("gotoPrevSlide", currentSlideIndex.current)
    //gotoSlide(currentSlideIndex-1)
    animateToSlideId(currentSlideIndex.current-1)
  };
  
  const toggleScrollListeners = (off) => {
    //return;
    // add/remove event listeners
    _isMobile = isMobileDevice();
    console.log("toggleScrollListeners off/isSmall/isMobile", off, isSmall, _isMobile)
    if(off) {
      _isListenersAdded.current = false
      if(!_isMobile) {
        console.log("!!! removed wheel/scroll")
        window.removeEventListener('wheel', onWheelScroll);
        window.removeEventListener('scroll', onDragScroll);
      } else {
        console.log("removed touch")
        window.removeEventListener('touchmove', onTouchMove);
        window.removeEventListener('touchstart', onTouchStart);
        ///window.removeEventListener('wheel', onWheelScroll);
        //window.removeEventListener('scroll', onDragScroll);
      }
      window.removeEventListener("keydown", handleKeyboard);
    } else {
      _isListenersAdded.current = true
      if(!_isMobile) {
        console.log("*** added wheel/scroll")
        //_.debounce(handleScroll,50));
        window.addEventListener('wheel', onWheelScroll, { passive: false });
        window.addEventListener('scroll', onDragScroll, { passive: false });
        //window.addEventListener('wheel', _.debounce(onWheelScroll,200), { passive: false });
        //window.addEventListener('scroll', _.debounce(onDragScroll,20), { passive: false });
      } else {
        console.log("added touch")
        window.addEventListener('touchmove', onTouchMove, { passive: false });
        window.addEventListener('touchstart', onTouchStart);
      }
      window.addEventListener("keydown", handleKeyboard);
    }


    
  };

  const disableScrollListeners = () => {
    console.log("toggleScrollListeners", isSmall, _isMobile)
    if(!_isMobile) {
      console.log("!!! removed wheel/scroll")
      window.removeEventListener('wheel', onWheelScroll);
      window.removeEventListener('scroll', onDragScroll);
    } else {
      console.log("removed touch")
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchstart', onTouchStart);
    }
  };

  const test = () => {
    console.log("!!! removed wheel/scroll")
    document.removeEventListener('wheel', onWheelScroll);
    document.removeEventListener('scroll', onDragScroll);
  };

  // can call these methods from parent with useRef, but CANT call internally with gotoSlide(1)
  useImperativeHandle(ref, () => {
    return { 
      //gotoSlideMod: (slideIndex) => gotoSlide(slideIndex),
      gotoSlideMod: (slideIndex) => animateToSlideId(slideIndex),
      gotoNextSlideMod: () => gotoNextSlide(),
      gotoPrevSlideMod: () => gotoPrevSlide(),
      //gotoNextFullPageMod: () => gotoNextFullPage(),
      getCurrentSlideIndexMod:() => getCurrentSlideIndex(),
      getCurrentSlideIndexFromControlsMod:() => getCurrentSlideIndexFromControls(),
      toggleScrollMod:(off) => toggleScrollListeners(off),
      forceToLastScrollPosMod:() => forceToLastScrollPos()
    }
  })
  
  // // update the pagination when scrolling
  // const handleScroll = event => {
  //   const currentScrollPos = window.scrollY;
  //   if(!slideHeight) {
  //     // only need to set this once - it's the main slide height
  //     //slideHeight = elementRef.current.clientHeight
  //     slideHeight = props.firstSlide.current.clientHeight;
  //   }
  //   if(!currentScrollY) {
  //     currentScrollY = 0;
  //   }
  //   if(true) {
  //     //const slideIndex = Math.ceil((currentScrollPos-slideHeight)/slideHeight);
  //     const buffer = 0;//(slideHeight*0.25);
  //     const slideIndex = Math.floor((currentScrollPos+buffer)/slideHeight);
  //     // console.log('window.scrollY', currentScrollPos, slideHeight, slideIndex);
  //     setCurrentSlideIndex(slideIndex);
  //     //updateTimelineDisplay(currentScrollPos || 0);
  //   }
    

  //   // UPDATE: switching to scroll snapping- when you scroll up- it snaps to previous page, scroll down- snap to next page
  //   const scrollDelta = currentScrollPos-currentScrollY
  //   console.log("handlescroll event", currentScrollPos, currentScrollY, scrollDelta)
  //   currentScrollY = currentScrollPos
  //   if(scrollDelta > 0) {
  //     console.log("goto next slide")
  //     //gotoNextSlide()
  //   } else if(scrollDelta < 0) {
  //     console.log("goto prev slide")
  //     //gotoPrevSlide()
  //   }
  // };
  // const handleScrollTest = event => {
  //   //console.log("handleScrollTest", isScrolling, event)
  //   isScrolling = true;
  // }
  // // copy/paste the funciton content
  // const doCustomScrolling = () =>  {
  //   const currentScrollPos = window.scrollY;
  //   if(!slideHeight) {
  //     // only need to set this once - it's the main slide height
  //     //slideHeight = elementRef.current.clientHeight
  //     slideHeight = props.firstSlide.current.clientHeight;
  //   }
  //   if(!currentScrollY) {
  //     console.log("reset currentScrollY", currentScrollY)
  //     currentScrollY = currentScrollPos;
  //   }
  //   // UPDATE: switching to scroll snapping- when you scroll up- it snaps to previous page, scroll down- snap to next page
  //   const scrollDelta = currentScrollPos-currentScrollY
  //   console.log("handlescroll event", currentScrollPos, currentScrollY, scrollDelta)
  //   //currentScrollY = currentScrollPos
  //   if(scrollDelta > 1) {
  //     console.log("goto next slide")
  //     gotoNextSlide()
  //   } else if(scrollDelta < 1) {
  //     console.log("goto prev slide")
  //     gotoPrevSlide()
  //   }
  // };

  // calculate what the current slide index SHOULD be based on the scrollbar
  // const getSlideIndexFromScrollPosition = () => {
  //   const scrollPos = window.scrollY || window.pageYOffset || 0;
  //   //const scrollTarget = currentScrollY 
  //   const node = document.getElementById('slide' + currentSlideIndex.current.toString());
  //   if(node) {
  //     const slidePos = node.offsetTop;
  //     const slideHeight = node.offsetHeight;
  //     if(scrollPos > slidePos+slideHeight) {

  //     }

  //     const diff = scrollPos - slidePos;
  //     console.log("diff", diff, slidePos, node.offsetHeight, currentSlideIndex.current)
  //     if(diff >= node.offsetHeight) {
  //       // we scrolled down the page- need to change slide index to NEXT
  //     }
  //   }
  //   return 0
  // };

  // TODO: when we detect a slide/page change animate the items on screen with fades/delays
  const onDragScroll = evt => {
    //return;
    if(!_isListenersAdded.current) return
    //console.log("onDragScroll", _isListenersAdded.current)
    if (_isScrollPending.current) {
      return;
    }
    
    //console.log("onDragScroll", evt);
    const scrollPos = window.scrollY || window.pageYOffset || 0;
    const scrollTarget = currentScrollY
    //console.log("onDragScroll", currentSlideIndex.current, scrollPos, scrollTarget, "animating:", _isScrollPending)
    //if(!_isScrollPending.current) {
      // if we are NOT animating to a page- we need to update the slide index automatically to match the current scrollbar
      //const slideIndex = getSlideIndexFromScrollPosition()
      const node = document.getElementById('slide' + currentSlideIndex.current.toString());
      if(node) {
        const slidePos = node.offsetTop;
        const slideHeight = node.offsetHeight;
        if(scrollPos <= 0) {
          const slideIndex = 0;
          setCurrentSlideIndex(slideIndex);
          setControlsUpdate(slideIndex); // fake state var to update controls
          console.log("! ZERO slide index:", currentSlideIndex.current, slideIndex, _isScrollPending.current)
          sendCustomEvent('onSlideAnimationComplete', slideIndex)
        } else if(scrollPos >= slidePos+slideHeight) {
          const slideIndex = currentSlideIndex.current+1
          setCurrentSlideIndex(slideIndex);
          setControlsUpdate(slideIndex); // fake state var to update controls
          console.log("! NEXT slide index:", currentSlideIndex.current, slideIndex, _isScrollPending.current)
          sendCustomEvent('onSlideAnimationComplete', slideIndex)
        } else if(scrollPos < slidePos-slideHeight){
          const slideIndex = currentSlideIndex.current-1
          setCurrentSlideIndex(slideIndex);
          setControlsUpdate(slideIndex); // fake state var to update controls
          console.log("! PREV slide index:", currentSlideIndex.current, slideIndex, _isScrollPending.current)
          sendCustomEvent('onSlideAnimationComplete', slideIndex)
        } 
      }
   // }
  };

  // scrollwheel copied from full-page  
  const onWheelScroll = evt => {
    
    if(!_isListenersAdded.current) return
    // if (this.props.scrollMode !== scrollMode.FULL_PAGE) {
    //   return;
    // }
    //console.log("onWheelScroll", _isListenersAdded.current)
    if(!getEnableFullPageScroll()) return;

    // TEST: if current slide height > 100% then implment the normal default scrolling
    //const currentSlide = props.children
    // const currentSlide = document.getElementById('slide' + currentSlideIndex.current.toString());
    // // const currentSlide = props.children[currentSlideIndex]
    // if(currentSlide && false) {
    //   //const slidePos = node.offsetTop;
    //   console.log("currentSlideIndex", currentSlideIndex.current, "clientHeight:", currentSlide.clientHeight, "slideHeight", slideHeight, "slideOffset", currentSlide.offsetTop)
    //   console.log("y", evt.wheelDelta, -evt.deltaY, -evt.detail, window.scrollY)
    //   if(currentSlide.clientHeight > slideHeight) {
    //     console.log("current slide height to big  -use default scrolling!")
    //     return;
    //   }
    //   //if(window.scrollY+slideHeight)
    // }

    //console.log("onWheelScroll", evt);
    evt.preventDefault();

    // FIXME: on macbook the wheel scroll has inertia which is causing extra scroll events after this animation completes
    // _isScrollPending is meant to stop this but the weird inertia thing is breaking
    // note this is fine with mouse scroll, only the 2 finger touchpad scroll cauisng issues
    //console.log("onWheelScroll", _isScrollPending.current, evt.wheelDelta, -evt.deltaY)
    if (_isScrollPending.current) {
      return;
    }

    // https://stackoverflow.com/questions/26326958/stopping-mousewheel-event-from-happening-twice-in-osx
    // https://github.com/alvarotrigo/fullPage.js/issues/1654
    // https://github.com/alvarotrigo/fullPage.js/issues/2407
    if(prevScrollTime.current) {
      var curTime = new Date().getTime();
      var timeDiff = curTime-prevScrollTime.current;
      if(timeDiff > delayedScrollPause) {
        console.log('New kinetic scroll has started!');
      } else {
        // here we are exiting and disabling scroll until time elapsed- means we have to wait between page scrolls
        //console.log("Blocking kinectic scroll by time delay:", timeDiff, "limit:", delayedScrollPause)
        return;
      }
      prevScrollTime.current = curTime;
    } 
    


    const scrollDown = (evt.wheelDelta || -evt.deltaY || -evt.detail) < 0;
    //console.log("scrollDown dir", scrollDown )
    // let { activeSlide } = this.state;

    // if (scrollDown) {
    //   activeSlide++;
    // } else {
    //   activeSlide--;
    // }

    // this.scrollToSlide(activeSlide);
    if(scrollDown) {
      console.log("goto next slide")
      gotoNextSlide()
    } else  {
      console.log("goto prev slide")
      gotoPrevSlide()
    }
  };

  const onTouchStart = evt => {
    if(!_isListenersAdded.current) return
    if(!getEnableFullPageScroll()) return;

    _touchStart = evt.touches[0].clientY;
    _isScrolledAlready = false;
    //console.log("onTouchStart", _touchStart)
  };

  const onTouchMove = evt => {
    if(!_isListenersAdded.current) return
    if(!getEnableFullPageScroll()) return;

    evt.preventDefault();
    const touchEnd = evt.changedTouches[0].clientY;
    //console.log("onTouchMove", touchEnd)

    if (!_isScrollPending.current && !_isScrolledAlready) {
      if (_touchStart > touchEnd + _touchSensitivity) {
        //this.scrollToSlide(this.state.activeSlide + 1);
        gotoNextSlide()
      } else if (_touchStart < touchEnd - _touchSensitivity) {
        //this.scrollToSlide(this.state.activeSlide - 1);
        gotoPrevSlide()
      }
    }
  };

  const handleKeyboard = evt => {
    //console.log(evt.key)
    if (_isScrollPending.current) {
      return;
    }
    if(evt.key == "ArrowDown") {
      gotoNextSlide()
    } else if(evt.key == "ArrowUp") {
      gotoPrevSlide()
    }
  };

  // when changing orientation- go back to top as it breaks stuff
  const onOrientationChange = evt => {
    console.log("!!! onorientationchange");
    // go back to slide 0 when changing orientation
    animateToSlideId(0)
  };

  // FIXED: using the slideCount to determine when all child nodes have been added
  useEffect(() => {
    // this thinks there are only 6 children???
    console.log("!!! slide count changed", props.slideCount, locationParams, location.pathname)
    // console.log("children changed", props.children.length, props.progressIcons.length)
    // const si = props.progressIcons.length-1
    // const node = document.getElementById('slide' + si.toString());
    // console.log("last node is valid?", node)
    // //props.children,
    if(props.slideCount > 4) {
      // we need to wait for the gallery child nodes to load which dont appear on first render
      //const si = props.slideCount-1
      //const node = document.getElementById('slide' + si.toString());
      //console.log("last node is valid?", node)

      // how do we change the url after a slide change: window.history.replaceState(null, "New Page Title", "/pathname/goes/here")

      if(locationParams.slideId) {
        // FIXME: doesnt work because the slides havesnt been added to DOM yet
        const sid = locationParams.slideId.split(":");
        if(sid.length > 0) {
          const slide = parseInt(sid[1])
          console.log("1b... has location param slideId:", locationParams.slideId, slide)
          if(currentSlideIndex.current != slide) {
            console.log("go...", slide)
            animateToSlideId( slide)
          } /*else {
            console.log("neh...")
            animateToSlideId( parseInt(sid[1]))
          }*/
        }        
      } 
    }

  }, [props.slideCount]);

  // init/setup
  useEffect(() => {
    _isMobile = isMobileDevice();
    // if(_isMobile) {
    //   // || isSmall
    //   enableFullPageScroll = false;
    // } else {
    //   enableFullPageScroll = true;
    // }

    console.log("NEW SlidesScroller reset window to 0,0 isMobile:", _isMobile);
    
    // not using
    slideHeight = props.firstSlide.current.clientHeight;
    // window.scroll = () => {
    //     // place the scroll handling logic here
    //     console.log("default window.scroll");
    // };
    //window.addEventListener('scroll',  _.debounce(handleScroll,50));
    // window.addEventListener('scroll',  handleScrollTest);
    //window.addEventListener('resize', _.debounce(checkRender, 50));
    
    toggleScrollListeners(false) // default is OFF(true)

    // if(!_isMobile) {
    //   document.addEventListener('wheel', onWheelScroll, { passive: false });
    //   document.addEventListener('scroll', onDragScroll, { passive: false });
    // } else {
    //   document.addEventListener('touchmove', onTouchMove, { passive: false });
    //   document.addEventListener('touchstart', onTouchStart);
    // }
    
   

    // get info about the props.childern
    //console.log(props.children)
    // for(var i=0; i < props.children.length; i++) {
    //   console.log(props.children[i])
    // }
    //maxSlides.current = props.children.length

    //setCurrentSlideIndex(3);
    //setCurrentSlideIndex(0)
    console.log("1. SlidesScroller setCurrentSlideIndex:", currentSlideIndex.current, "icons:", props.progressIcons.length, "slide count:", props.slideCount, "_isMobile", _isMobile, "locationParams:", locationParams, "children:", props.children)
    //console.log("SlidesScroller useEffect/did mount. isMobile:", _isMobile)

    // FORCE RESET TO slide 0 + window(0,0)? what if slideID?    
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // if(currentSlideIndex.current != 0) {
    //   console.log("2a. SlidesScroller force animating to slide 0")
    //   animateToSlideId(0)      
    // } else {
    //   // slide index == 0
    //   animatedScrollTo(0, 100, () => {
    //     console.log("2b. SlidesScroller animatedScrollTo constructor 100ms delay complete")        
    //   });
    // }
    // FIXED: doing a standard refresh from halfway down the page was causing the slideindex to attempt to jump back down the page instead of 0
    animateToSlideId(0)  

    // TODO: if we are using url schemes for navigating this doesnt work
    setCurrentSlideIndex(0);    
    updateUrlHistory()
    
    
    
    // setInterval(() => {
    //   if (isScrolling) {
    //     isScrolling = false;
    //     // place the scroll handling logic here
    //     doCustomScrolling()
    //     currentScrollY = window.scrollY
    //     console.log("reset isScrolling", currentScrollY)
    //   }
    // },2000);

    if ('onorientationchange' in window) {
        window.addEventListener("orientationchange", onOrientationChange, false);
    }
    
    return () => {
      //window.removeEventListener('scroll', handleScroll);
      toggleScrollListeners(true)
      // if(!_isMobile) {
      //   document.removeEventListener('wheel', onWheelScroll);
      //   document.removeEventListener('scroll', onDragScroll);
      // } else {
      //   document.removeEventListener('touchmove', onTouchMove);
      //   document.removeEventListener('touchstart', onTouchStart);
      // }
      window.removeEventListener("orientationchange", onOrientationChange);
    };
  }, [isSmall]);

  // reset to top of page when broswer resize? this is buggy on ios
  /*useEffect(() => {
    console.log("notes w/h changed:", deviceWidth,deviceHeight,  currentSlideIndex.current)
    // window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    //window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    animatedScrollTo(0, 100, () => {
      
      if(currentSlideIndex.current != 0) {
        console.log("changing slide index to 0")
        setCurrentSlideIndex(0);
        setControlsUpdate(0); 
      }
      
    });
    
  }, [deviceWidth,deviceHeight]);*/
  useEffect(() => {
    console.log("notes w/h changed:", deviceWidth,deviceHeight,  currentSlideIndex.current)
    //animateToSlideId(currentSlideIndex.current)

    // this is sumulating animate to slide: but where going to the same/current slide index and ignoring the scrollpending stuff
    const node = document.getElementById('slide' + currentSlideIndex.current.toString());
    if(node) {
      const slidePos = node.offsetTop;
      currentScrollY = slidePos; // save the target position for later
      _lastSavedScrollY.current = slidePos;
      animatedScrollTo(slidePos, 50, () => {
      });
    }
    
  }, [deviceWidth,deviceHeight]);

  return (

    <div id={props.id}>
      
      {/* <Header /> */}
      {/* FIXME: set a -1 tab index on this container and focus when changing state. this allows us to 'reset' the tabindex  ref={containerRef} */}
      <div className='flex flex-col w-auto overflow-x-hidden' onKeyUp={handleKeyboard} tabIndex="-1">
        {/* <VideoBackground url={bgVideo}  /> */}
        {/* <div class='fixed top'>{currentSlideIndex}</div> */}


        {/* content slides */}
        {/* https://github.com/zwug/react-full-page : scrollMode="normal" */}
        {/* <FullPage ref={fullPageRef} controls={ScrollerCustomControls} controlsProps={{progressIcons:props.progressIcons, showControls:!isSmall}} duration={900} scrollMode={(isSmall || true) ? "normal" : "full-page"}> */}
          {/* progressIcons={props.progressIcons} */}
        {/* <Slide key="0" style={{background:"#ff0000", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Hello1</Slide> */}
        {/* <Slide key="1" style={{background:"#ff00ff",display: 'flex', alignItems: 'center', justifyContent: 'center'}}>Hello2</Slide>      */}

        {/* <button className='mt-20 z-10' onClick={() => disableScrollListeners()}>Yo              
            </button> */}
        { 
          React.Children.map(props.children, (child,index) =>
            // <Slide key={index} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} >{child}</Slide>
            <div key={index} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
              {child}
            </div>
          )
        }
        {/* // {props.children} */}
        {/* <Slide key="2" style={{background:"#ff00ff",display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          Hello3
        </Slide>  */}
            
    
        {/* </FullPage> */}

        {/* scroller navigation with icons- dont need this if we are using the fullpage controls version */}
        {
          (!isSmall) &&
            <ScrollerControls progressIcons={props.progressIcons} animateToSlideId={animateToSlideId} controlsUpdate={controlsUpdate}></ScrollerControls>
            // <div className='fixed top-1/2 right-5 transform -translate-y-1/2 w-8 z-20 text-center'>
            //   <div className='flex flex-col items-center justify-center'> 
            //     {props.progressIcons.map((elementInArray, index) => ( 
            //         // <div className="" key={index}> Whatever needs to be rendered repeatedly... </div> 
            //         <ScrollerIcon active={controlsUpdate == index} icons={props.progressIcons[index]} src={props.progressIcons[index]} key={index} onClick={() => animateToSlideId(index)} />
                    
            //         ) 
            //     )}
            //     {controlsUpdate}
            //   </div>
            // </div>
        }
                    
        
      </div>
      
    </div>
    
  )
})

// export default SlidesScroller 
export {
  SlidesScroller
}